import { create } from "zustand"
import { combine, persist } from "zustand/middleware"
import { Study } from "../types/types"

export const useWelcomeStore = create(
  persist(
    combine(
      {
        studyId: null as undefined | null | string,
        study: null as Study | undefined | null
      },
      (set) => ({
        setStudyId: (studyId: string | null) => set({ studyId }),
        setStudy: (study: Study | null) => set({ study })
      })
    ),
    { name: "welcome" }
  )
)
